module.exports = __webpack_public_path__ + "img/orbr.88b59bc6.svg";